import { ReactNode, useMemo } from "react";

import styles from "./AccountDetailDescription.module.scss";

interface AccountDetailDescriptionProps {
    label?: string;
    value?: ReactNode;
    valueColor?: "default" | "red";
    isPopup?: boolean;
}

function AccountDetailDescription(props: Readonly<AccountDetailDescriptionProps>): JSX.Element {
    const { label, value, valueColor = "default", isPopup } = props;

    const colorStyles = useMemo<string>(
        () => valueColor === "red" ? styles.descriptionValueRed : styles.descriptionValueBlue,
        [valueColor]
    );

    return (
        <div className={`${isPopup ? styles.descriptionItem : styles.descriptionItemBig}`}>
            <div className={styles.descriptionLabel}>{label}</div>

            <div className={styles.descriptionValue + " " + colorStyles}>{value}</div>
        </div>
    );
}

export { AccountDetailDescription };
